import type { LineMoney } from '@peles/shared';
import { StatusBadge } from '../../common/EntityList';
import { moneyBadge } from './moneyDisplay';

/** Where a line's money stands — Overdue, Unpaid, Partly paid, Paid, Overpaid. */
export function MoneyStateBadge({ money }: { money: LineMoney }) {
  const { label, color } = moneyBadge(money);
  return <StatusBadge label={label} color={color} />;
}
